var render, staticRenderFns
import script from "./grasping_rules.vue?vue&type=script&lang=js"
export * from "./grasping_rules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8f2ec38')) {
      api.createRecord('c8f2ec38', component.options)
    } else {
      api.reload('c8f2ec38', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms/views/grasping_rules/grasping_rules.vue"
export default component.exports